export default {
  p1: 'We donate some of our revenue from every search towards helping animals in need.',
  p2: 'We don’t store your searches permanently and your data is secure.',
  getStarted: 'Get started with Cheerie',
};
